import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaVerificationInterface } from '../../models/dashboard/ba-verification/ba-verification';

interface IInitialState {
    verificationStats?: BaVerificationInterface;
}

const initialState: IInitialState = {
    verificationStats: undefined
};

const baVerificationStatsSlice = createSlice({
    name: 'baVerificationStatsSlice',
    initialState,
    reducers: {
        setVerificationStats(state, action: PayloadAction<BaVerificationInterface>) {
            state.verificationStats = action.payload;
        },
    },
});

export const baVerificationStatsActions = baVerificationStatsSlice.actions;
export default baVerificationStatsSlice.reducer;
